import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'

interface NotificationArgs {
  type: 'success' | 'error'
  message: string
}
export default function useNotification() {
  const dispatch = useDispatch()

  return useCallback(
    (arg: NotificationArgs | string) => {
      dispatch(
        showTransientNotification(
          typeof arg === 'string' ? { type: 'success', message: arg } : arg
        )
      )
    },
    [dispatch]
  )
}
